import Work1 from "../../assets/work1.png";
import Work2 from "../../assets/work2.png";
import Work3 from "../../assets/work3.png";
import Work4 from "../../assets/work4.png";
import Work5 from "../../assets/work5.png";
import Work6 from "../../assets/work6.png";
import Work7 from "../../assets/work7.png";
import Work8 from "../../assets/work8.png";
import Work9 from "../../assets/work9.png";
import Work10 from "../../assets/work10.png";




export const projectsData = [
  {
    id: 10,
    image: Work10,
    title: "Apoena",
    category: "Full-Stack",
    demoLink: "https://djapoena.com",
    description:
      "Entwickelt mit React.js",
  },
  {
    id: 1,
    image: Work1,
    title: "MS E-Commerce",
    category: "Full-Stack",
    demoLink: "https://ms-design.vercel.app/tshirts",
    description:
      "Entwickelt mit React/ContextAPI und einer herausragenden Komponentenstruktur, während ich kontinuierlich dazulerne. Mit Fokus auf E-Commerce-Lösungen.",
  },
  {
    id: 2,
    image: Work2,
    title: "Hope2Hand",
    category: "Full-Stack",
    demoLink: "https://hope2hand.netlify.app/",
    description:
      "Hoffnung2Hand war das abschließende Abschlussprojekt des 1-jährigen Kurses, der von (DCI) angeboten wurde. Es war großartig, ich habe viel gelernt",
  },

  {
    id: 3,
    image: Work3,
    title: "Chuck_Jokes",
    category: "Full-Stack",
    demoLink: "https://api-chuck.onrender.com/",
    description:
      "Die berühmten Chuck-Norris-Witze, aber mit einem besonderen Dreh. Ich habe die API der bekannten Website icndb.com verwendet.",
  },
  {
    id: 4,
    image: Work4,
    title: "Unsplash_API",
    category: "Full-Stack",
    demoLink: "https://unsplash-jqqo.onrender.com/",
    description:
      "Ein weiteres gutes Werk, das von Joseph Obina zusammengestellt wurde und uns die Möglichkeit gab, durch ihn zu lernen. (DCI)",
  },
  {
    id: 5,
    image: Work5,
    title: "ChatGPT",
    category: "Utilities",
    demoLink: "https://chatgptfront.onrender.com/",
    description:
      "Dieses Projekt wurde kürzlich erstellt. Ich habe erfolgreich die Aufgabe erfüllt, einen GPT-Chat zu erstellen, der sprechen und zuhören kann.",
    },
    {
      id: 6,
      image: Work6,
      title: "Wetter App",
      category: "Full-Stack",
      demoLink: "https://weather-app-ul62.onrender.com/",
      description:
        "Projekt entwickelt mit React/ContextAPI, ausgezeichnete Komponentenaufteilung und großartiges Lernen.",
  },
  {
    id: 7,
    image: Work7,
    title: "Chat Dashboard",
    category: "Utilities",
    demoLink: "https://flamescalculator.netlify.app/",
    description: "Ein Projekt, das ich mit Tkinter in Python entwickelt habe, um die Funktionsweise der Benutzeroberflächenentwicklung zu erkunden.",
  },
  {
    id: 8,
    image: Work8,
    title: "Old Portfolio",
    category: "Design",
    demoLink: "https://carlos-pereira-portfolio.vercel.app/",
    description: "Das Projekt wurde mit Figma/LocoFy und React umgesetzt. Es war eine herausragende Lernerfahrung.",
  },
  {
    id: 9,
    image: Work9,
    title: "Thiago Rouede",
    category: "Design",
    demoLink: "https://tiagorouede.vercel.app/",
    description: "Eines meiner ersten HTML/CSS-Designs.",
  },
];

export const projectsNav = [
  {
    name: "All",
  },
  {
    name: "Full-Stack",
  },
  {
    name: "Utilities",
  },
  {
    name: "Design",
  },
];
